//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { selectCostListNumb,selectAxpeAccolist,selectExpeAcco,deleteReim,FILE_URL } from '@/api/rem/cost/cost';
import {DORM,JPT_URL,BASIC,DORM_URL} from "@/config/constant"
import promise from '@/axios/promise'
import SlipDel from 'vue-slip-delete'
var page=1;
var limit=10;
var reimStu=''
export default{
  components: {

    SlipDel
  },
  filters: {
    numFilter(value) {
    // 截取当前数据到小数点后两位
  //     let realVal = value.substring(0,value.length-2)
  //     // num.toFixed(2)获取的是字符串
  //     return realVal
    }
  },
  data(){
    return{
      num: 10,
      didiNum:10,
      refreshing: false,
      loading: false,
      text: 'List',
      checkbox:'',
      dataList:[],
      open: false,
      file_URL:FILE_URL,
      active1:'0'
    }
  },
  created(){
    promise({
      url:DORM+"/expense/selectDictionType",
      method:"get",
      async:false,
      params:{type:"fileUrl"}
    }).then(res=>{
        console.log(res);
        this.file_URL=res[0].dicCode
    });
    page=1;
    limit=10;
    var pageLimit={'page':page,'limit':limit}
    selectAxpeAccolist(pageLimit).then(response =>{
      this.dataList=response.data;
      for(var i=0;i<this.dataList.length;i++){
        if(this.dataList[i].costIcon!=''&&this.dataList[i].costIcon!=undefined){
          var fileURl=this.dataList[i].costIcon.split(',');
          for(var k=0;k<fileURl.length;k++){
            fileURl[k]=this.file_URL+fileURl[k]
          }
          this.dataList[i].costIcon=fileURl;
        }
      }
       console.log(this.dataList)
    })
    promise({
      url:DORM+"/expense/selectDictionType",
      method:"get",
      async:false,
      params:{type:"fileUrl"}
    }).then(res=>{
        console.log(res);
        this.file_URL=res[0].dicCode
    });

  },
  methods:{
    changeStatus(){
       if(this.active1==0){
          // this.statusChange('待审批');
          this.reimListSelect('')
      }else if(this.active1==1){
        // this.statusChange('已通过');
        this.reimListSelect('审批中')

      }else if(this.active1==2){
        // this.statusChange('被驳回');
        this.reimListSelect('已驳回')

      }else if(this.active1==3){
        this.reimListSelect('已报销')
      }
    },
    //返回
    callBack(){
      this.$router.push({path:'/'});
    },
    //报销编号检索
    costNumbSelect(){
      var costNumb = document.getElementById('costNumb').value;
      console.log(costNumb)
      page=1;
      limit=10;
      this.dataList=''
      var pageLimit={'page':page,'limit':limit,'reimNumber':costNumb,'reimStu':reimStu}
      selectAxpeAccolist(pageLimit).then(response =>{
        this.dataList=response.data;
        for(var i=0;i<this.dataList.length;i++){
          if(this.dataList[i].costIcon!=''&&this.dataList[i].costIcon!=undefined){
            var fileURl=this.dataList[i].costIcon.split(',');
            for(var k=0;k<fileURl.length;k++){
              fileURl[k]=this.file_URL+fileURl[k]
            }
            this.dataList[i].costIcon=fileURl;
          }
        }
      })
    },//清除清除编号
    clearCostNumb(){
      document.getElementById('costNumb').value='';
      page=1;
      limit=10;
      var pageLimit={'page':page,'limit':limit,'reimStu':reimStu}
      selectAxpeAccolist(pageLimit).then(response =>{
        this.dataList=response.data;
        for(var i=0;i<this.dataList.length;i++){
          if(this.dataList[i].costIcon!=''&&this.dataList[i].costIcon!=undefined){
            var fileURl=this.dataList[i].costIcon.split(',');
            for(var k=0;k<fileURl.length;k++){
              fileURl[k]=this.file_URL+fileURl[k]
            }
            this.dataList[i].costIcon=fileURl;
          }
        }
      })
    },//跳转详情
    costListClick(reimId){
      console.log(reimId)
      var fid={'fid':reimId}
      selectExpeAcco(fid).then(response =>{
        console.log(response);
        if(response.reimType=='审批中'||response.reimType=='已报销'){
          this.$router.push({ path: '/reimSee',query:{reimData:response,businessKey:response.fid}})
        }else{
          this.$router.push({ path: '/reimEdit',query:{reimData:response}})
        }
      })
    },//新建报销单
    newRiem(){
      this.$router.push({ path: '/reimDetail'})
    },
    refresh () {
    	debugger;
          this.refreshing = true;
          this.$refs.container.scrollTop = 0;
          this.refreshing = false;
          // setTimeout(() => {
          //   this.refreshing = false;
          //   var pageLimit={'page':page,'limit':limit}
          //   selectAxpeAccolist(pageLimit).then(response =>{
          //     if(response.data.length!='0'){
          //       this.dataList.push(response.data)
          //     }
          //   })
          // }, 1000)
      },
      load () {
        page++;
         this.loading = true;
         setTimeout(() => {
            this.loading = false;
            var costNumb = document.getElementById('costNumb').value;
            var pageLimit={'page':page,'limit':limit,'reimNumber':costNumb,'reimStu':reimStu}
            selectAxpeAccolist(pageLimit).then(response =>{
              // console.log(response);
              if(response.data.length!=0){
                for(var i=0;i<response.data.length;i++){
                  if(response.data[i].costIcon!=''&&response.data[i].costIcon!=undefined){
                    var fileURl=response.data[i].costIcon.split(',');
                    for(var k=0;k<fileURl.length;k++){
                      fileURl[k]=this.file_URL+fileURl[k]
                    }
                    response.data[i].costIcon=fileURl;
                  }
                  this.dataList.push(response.data[i])
                }
              }
            })
        }, 500)
      },//全部
      reimListSelect(type){
        reimStu=type
        page=1;
        limit=10;
        var pageLimit={'page':page,'limit':limit,'reimStu':reimStu}
        selectAxpeAccolist(pageLimit).then(response =>{
          this.dataList=response.data;
          for(var i=0;i<this.dataList.length;i++){
            if(this.dataList[i].costIcon!=''&&this.dataList[i].costIcon!=undefined){
              if(this.dataList[i].costIcon!=''&&this.dataList[i].costIcon!=undefined){
                var fileURl=this.dataList[i].costIcon.split(',');
                for(var k=0;k<fileURl.length;k++){
                  fileURl[k]=this.file_URL+fileURl[k]
                }
                this.dataList[i].costIcon=fileURl;
              }
            }
          }
        })
      },
      del(index,reimType,indexSub) {
        // 删除回调
        var _this=this;
        if(reimType=='编辑中'){
          console.log(index)
          var fid={'id':index.fid}
          deleteReim(fid).then(res=>{
            console.log(res);
            _this.dataList.splice(indexSub,1)
          })
        }
      },
      //滑动
      slipOpen(vm) {
        // 无需手动关闭
      },
  }
}



// WEBPACK FOOTER //
// ./src/components/reimList.vue